<template>
  <router-view />
  <ErrorPopup />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* 전역 스타일은 global.css / tokens.css에서 가져오기 때문에 여기선 비워둬도 됨 */
</style>
